// FetchOffersOverview POST /api/2.0/offers/fetch_offers_overview
import { api } from "services/api/service";
import { API_FETCH_ACTIVE_OFFERS, API_FETCH_USER_OFFERS, API_UPDATE_OFFER } from "constants/api";
import type { ApiResponse } from "services/api/types";

export const getActiveOffers = async (): Promise<ApiResponse<any>> => {
	return (await api()).post(API_FETCH_ACTIVE_OFFERS);
};

interface Payload {
	card_no?: string;
}

interface UpdateOffersPayload {
	user_offer_ids: string[];
	card_no: string;
	start_date: string;
	end_date: string;
	remarks: string;
}
export const fetchUserOffer = async (payload: Payload): Promise<ApiResponse<any>> => {
	return (await api()).post(API_FETCH_USER_OFFERS, payload);
};

export const updateOffers = async (payload: UpdateOffersPayload): Promise<ApiResponse<any>> => {
	return (await api()).post(API_UPDATE_OFFER, payload);
};
